/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.0.0
 * @since 1.0.1
 */

import styled, { keyframes } from 'styled-components';

export const bigLoaderShimmer = keyframes`
    0% {
        background-position: -100px;
    }
    100% {
        background-position: 364px;
    }
`;

export const smallLoaderShimmer = keyframes`
    0% {
        background-position: -80px;
    }
    50%, 100% {
        background-position: 172px;
    }
`;

export const LoaderAnimation = styled.div`
    backface-visibility: hidden;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-fill-mode: forwards;
`;

